/* src/app/components/app-button/button.style.css */
button ::ng-deep .mdc-button__label {
  display: flex;
  column-gap: 10px;
  align-items: center;
  justify-content: center;
}
button.active {
  cursor: not-allowed;
}
button {
  margin-left: 8px;
}
/*# sourceMappingURL=button.style-V5AU3KJA.css.map */
